// Channel tag visibility per editor type — PRD BK-3229 Req 3 AC 3.1.2.
// `any`-tagged templates are always visible, so the server-side scope merges
// `any` into every non-null query. Editors mapped to `["any"]` restrict the
// library to templates that are ONLY channel-agnostic (landing pages, etc.).
const CHANNELS_BY_EDITOR = Object.freeze({
  email: ["email"],
  log_email: ["email"],
  sms: ["sms"],
  log_text: ["sms"],
  phone_call: ["call_script", "note"],
  // BK-3229: the General Note composer also surfaces call-script templates,
  // not just the phone-call composer.
  note: ["note", "call_script"],
  appointment: ["email", "note"],
  log_appointment: ["email", "note"],
  task: ["note"],
  landing_page: ["any"],
  signature: ["any"],
  job_posting: ["any"],
});

// Returns the channel tags to filter the library by, or null when the editor
// type is unknown. A null return tells the caller to omit the channel filter
// entirely (PRD AC 3.3.1 fallback: show all templates).
const channelsForEditor = (editorType) =>
  CHANNELS_BY_EDITOR[editorType] ?? null;

export { channelsForEditor, CHANNELS_BY_EDITOR };
